import  React from 'react'
import Button from 'react-bootstrap/Button'

export interface SaveCancelButtonsProps {
    saveLabel?: string
    cancelLabel?: string
    removeLabel?: string
    onCancel?: { (): any }
    onRemove?: { (): any }
    onSave?: { (): any }
}

export const SaveCancelButtons: React.FC<SaveCancelButtonsProps> = (props: SaveCancelButtonsProps) => (
  <div className="clearfix mt-3">
    <Button className="emdg-btn  float-right" onClick={props.onSave} style={{ display: props.onSave ? '' : 'none' }}>
      {props.saveLabel || 'Save & continue'}
    </Button>
    <Button  className="emdg-btn emdg-btn--secondary float-left" onClick={props.onCancel} style={{ display: props.onCancel ? '' : 'none' }}>
      {props.cancelLabel || 'Cancel'}
    </Button>
    <Button  className="emdg-btn emdg-btn--secondary float-left ml-3" onClick={props.onRemove} style={{ display: props.onRemove ? '' : 'none' }}>
      {props.removeLabel || 'Remove'}
    </Button>
  </div>
)
